import type {CbRewardRecordData, CbRewardRecordItem} from './reducers'

/** 本地预览开关；联调真实接口时改为 false */
export const USE_MOCK_CB_REWARD_RECORD = false

const MOCK_ICON = 'https://img01.mehiya.com/img/png/id/432604807202'

const MOCK_NAMES = [
  'chat card *30, for free chatting',
  'game card *10, for lucky games',
  'gift pack *5, limited edition',
  'lucky gift *20, room exclusive',
]

const MOCK_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]

const MOCK_RECORD_TOTAL = 36

const buildMockRecordItem = (index: number): CbRewardRecordItem => {
  const day = Math.max(1, 28 - (index % 28))
  const hour = 10 + (index % 12)
  const minute = (index * 7) % 60

  return {
    icon: MOCK_ICON,
    name: MOCK_NAMES[index % MOCK_NAMES.length],
    level: MOCK_LEVELS[index % MOCK_LEVELS.length],
    claim_time: `2026-6-${day} ${hour}:${minute.toString().padStart(2, '0')}:00`,
    scheme: '',
  }
}

const MOCK_RECORD_ALL: CbRewardRecordItem[] = Array.from(
  {length: MOCK_RECORD_TOTAL},
  (_, index) => buildMockRecordItem(index)
)

export const getMockCbRewardRecord = (
  offset: number,
  limit: number
): CbRewardRecordData => {
  const list = MOCK_RECORD_ALL.slice(offset, offset + limit)
  const nextOffset = offset + list.length

  return {
    err_msg: '',
    list,
    offset: nextOffset,
    more: nextOffset < MOCK_RECORD_ALL.length,
  }
}

/** @deprecated 使用 getMockCbRewardRecord */
export const MOCK_CB_REWARD_RECORD: CbRewardRecordData = getMockCbRewardRecord(
  0,
  20
)

export const MOCK_CB_REWARD_RECORD_EMPTY: CbRewardRecordData = {
  err_msg: '',
  offset: 0,
  more: false,
  list: [],
}
